import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import reparaturontstants from "../Constants/ReparaturContstants";

let result = null;

class ReparaturStore extends EventEmitter {
  getResult() {
    return result;
  }

  setResult(res) {
    result = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case reparaturontstants.GET_RUECKMELDUNGVORLAGE_SUCCESS:
        this.setResult(action.result);
        break;
      case reparaturontstants.GET_RUECKMELDUNGVORLAGE_FAILURE:
        this.setResult(null);
        break;
      case reparaturontstants.GET_REPARTURLIST_SUCCES:
        this.setResult(action.result);
        break;
      case reparaturontstants.GET_REPARTURLIST_FAILURE:
        this.setResult(null);
        break;
      case reparaturontstants.ADD_REPARATUR_SUCCESS:
        this.setResult(action.result);
        break;
      case reparaturontstants.ADD_REPARATUR_FAILURE:
        this.setResult(action.result);
        break;

      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const reparaturStore = new ReparaturStore();
dispatcher.register(reparaturStore.handleCallback.bind(reparaturStore));
export default reparaturStore;
